import { render, staticRenderFns } from "./buyRule.vue?vue&type=template&id=2a68d66e&scoped=true"
import script from "./buyRule.vue?vue&type=script&lang=js"
export * from "./buyRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68d66e",
  null
  
)

export default component.exports